export const regionColors = {
  'US': '#f6274e',
  'EU': '#2185d0',
  'AS': '#60b21f',
  'Rest': '#fd6b3d',
};

export const textColor = '#ddd';
export const axisColor = '#ddd';
export const markerColor = '#f6c22c';
export const colorGoMarker = '#5e6b7f';
export const backgroundAreaColor = '#5e6b7f';

export const yearCanvasColor = '#5e6b7f';
export const separateTitleColor = '#C4C9D0';
